import Image from 'next/image';
/* eslint-disable @next/next/no-img-element */

// eslint-disable-next-line @next/next/no-img-element
import { UilAngleDown, UilAngleRight } from '@iconscout/react-unicons';

const ProductTable = (props) => {
  const { dropdown, isOpen, image = '/example.png', name = 'Title' } = props;

  return (
    <div className='flex items-center'>
      {image && (
        <img
          className='rounded-md'
          src={image}
          width={32}
          height={32}
          alt='/role.png'
        />
      )}

      <span className={image ? 'mx-3' : 'ml-11'}>{name}</span>
      {dropdown && isOpen && <UilAngleDown color='#1F4BFF' />}
      {dropdown && !isOpen && <UilAngleRight color='#1F4BFF' />}
    </div>
  );
};

export default ProductTable;
